import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-download-archive-dialog',
    templateUrl: './download-archive-dialog.component.html',
    styleUrls: ['./download-archive-dialog.component.scss'],
    standalone: false
})
export class DownloadArchiveDialogComponent {
    public folderPath: string;
    public fileServer: 'austin' | 'amazon' = 'austin';

    constructor(private dialogRef: MatDialogRef<DownloadArchiveDialogComponent, string>) { }

    startDownload() {
        const oldFormatString = `\\\\${this.fileServer}\\${this.folderPath.replace(':', '')}`;
        this.dialogRef.close(oldFormatString);
    }
}